import type { HTMLAttributes } from 'react';
import useGlobalStyles from '@/styles/global.styles';

interface IProps extends HTMLAttributes<HTMLHeadElement> {
  classNameOverride?: string;
  level: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
}

export default function Heading({
  level = 'h1',
  children,
  className,
  classNameOverride,
  ...rest
}: IProps) {
  const { classes, cx } = useGlobalStyles({ fixed: true });
  const Tag = level;

  const isString = typeof children === 'string';
  let modifiedHeading = children;

  if (isString) {
    modifiedHeading = children.replaceAll('{{NEWLINE}}', '\n');
  }

  return (
    <Tag
      style={{ ...(isString && { whiteSpace: 'pre-wrap' }) }}
      className={classNameOverride ?? cx(classes[level], className)}
      {...rest}
    >
      {modifiedHeading}
    </Tag>
  );
}
